module.exports = __webpack_public_path__ + "static/media/logo-white.4ef698e1.png";